/**
 * Created by Mikhail Menshenin on 28.01.2026
 */

const LevelHashCheck = function () {
    const episodesAmount = cleverapps.user.getEpisodesAmount();
    const actions = [];
    const hashes = {};
    cleverapps.rangeArray(0, episodesAmount - 1).forEach(function (episodeNo) {
        actions.push(function (f, stop) {
            cleverapps.bundleLoader.loadBundles([Level.BundleId(episodeNo)], {
                onSuccess: f,
                onFailure: stop
            });
        });
        cleverapps.rangeArray(0, 14).forEach(function (levelNo) {
            actions.push(function (f) {
                const level = new Level(episodeNo, levelNo);
                const levelNum = level.getHumanReadableNumber();
                level.setupContent();
                if (!hashes[level.hash]) {
                    hashes[level.hash] = [];
                }
                if (hashes[level.hash].indexOf(levelNum) === -1) {
                    hashes[level.hash].push(levelNum);
                }
                f();
            });
        });
    });
    actions.push(function (f) {
        Object.values(hashes).forEach(function (levels) {
            if (levels.length > 1) {
                console.error(`Levels wuth same hashes ${levels.join(", ")}`);
            }
        });
        f();
    });
    new ActionPlayer(actions).play();
};